document.addEventListener('DOMContentLoaded', function () {
    const posts = document.querySelectorAll('.type-newsletter');
    posts.forEach(post => {
        if (post.querySelector('.ctdqb-divi-layout-content .et_pb_code_inner')) {
            const postLink = post.querySelector('.ctdqb-post-link');
            if (postLink) {
                postLink.style.display = 'none';
            }
        }
    });
});
